export { default } from './safe-image';
